import { NumbersOnlyTextField } from '@cibo/ui'
import { GridRenderEditCellParams } from '@mui/x-data-grid'
import { useSnackbar } from 'notistack'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface NumberEditInputProps extends GridRenderEditCellParams {
  max?: number
  min?: number
  step?: number
  canFloat?: boolean
}

export function NumberEditInput({
  id,
  field,
  value,
  api,
  min,
  max,
  canFloat,
  ...rest
}: NumberEditInputProps) {
  const { t } = useTranslation('@cibo/landmanager/NumberEditInput')

  const { enqueueSnackbar } = useSnackbar()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value

    if (
      newValue === '' ||

      (min !== undefined && +newValue <= min) ||
      (max !== undefined && +newValue >= max)
    ) {
      enqueueSnackbar(t('numberOutOfRange', { max, min }), {
        variant: 'warning',
      })
      api.setEditCellValue(
        {
          id,
          field,
          value: newValue,
        },
        event
      )
    }

    api.setEditCellValue({ id, field, value: newValue }, event)
  }

  return (
    <NumbersOnlyTextField
      value={value || ''}
      onChange={handleChange}
      slotProps={{ input: { inputProps: { inputMode: 'numeric' } } }}
      fullWidth
      autoFocus
      canFloat={canFloat}
      {...rest}
    />
  )
}
